import React, { ReactNode } from 'react';

import cx from 'clsx';

import styles from '../Addons.module.scss';
import postfixStyles from './Postfix.module.scss';

type PostfixProps = {
  content?: ReactNode;
  className?: string;
};

export const Postfix = ({ content, className }: PostfixProps) =>
  content ? <span className={cx(className, postfixStyles.postfix, styles.addon)}>{content}</span> : null;
